module.exports = __webpack_public_path__ + "static/media/team_5.990c4a41.png";